import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTablet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.7998 4.59985C21.352 4.59985 21.7997 5.04766 21.7998 5.59985V18.3997C21.7998 18.9519 21.3521 19.3997 20.7998 19.3997H3.2002C2.648 19.3996 2.2002 18.9519 2.2002 18.3997V5.59985C2.2003 5.04772 2.64807 4.59996 3.2002 4.59985H20.7998ZM3.2002 5.59985V18.3997H13.6006V5.59985H3.2002ZM14.4004 11.5999H20.7998V12.3997H14.4004V18.3997H20.7998V12.3997L20.8008 11.5999H20.7998V5.59985H14.4004V11.5999Z",
		fill: "currentColor"
	})
});
export default SvgTablet;
